import { StyleSheet } from 'react-native';
import Theme from '../theme';
import { defaultScale, scaleText } from '../utils/scaling';

export const sharedStyles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: defaultScale(16),
    backgroundColor: Theme.WHITE,
  },
  bookingSelectionTitle: {
    fontSize: Theme.textStyle.heading.fontSize,
    fontFamily: Theme.textStyle.heading.fontFamily,
    textAlign: 'center',
  },
  bookingSelectionSubtitle: {
    marginBottom: defaultScale(5),
    paddingTop: defaultScale(6),
    fontSize: scaleText(16),
    textAlign: 'center',
    fontFamily: Theme.Weight400,
  },
  selectionContainer: {
    paddingHorizontal: defaultScale(30),
    marginBottom: defaultScale(10),
  },
});
